var _path, _path2, _g, _path3, _path4, _path5, _path6, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotifyMeRed = function SvgNotifyMeRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 18.341c0 .9-.916 1.66-2 1.66s-2-.76-2-1.66v-.34h4v.34Zm6.521-3.134-1.8-1.803V8.936c0-3.48-2.503-6.437-5.822-6.877a6.724 6.724 0 0 0-5.316 1.607A6.731 6.731 0 0 0 5.28 8.727v4.677l-1.8 1.804a1.63 1.63 0 0 0-.355 1.782c.255.613.848 1.01 1.512 1.01H8v.341c0 2.018 1.794 3.66 4 3.66s4-1.642 4-3.66v-.34h3.362a1.63 1.63 0 0 0 1.511-1.01 1.632 1.632 0 0 0-.352-1.784Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Notify_me_red_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 18,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 18.341c0 .9-.916 1.66-2 1.66s-2-.76-2-1.66v-.34h4v.34Zm6.521-3.134-1.8-1.803V8.936c0-3.48-2.503-6.437-5.822-6.877a6.724 6.724 0 0 0-5.316 1.607A6.731 6.731 0 0 0 5.28 8.727v4.677l-1.8 1.804a1.63 1.63 0 0 0-.355 1.782c.255.613.848 1.01 1.512 1.01H8v.341c0 2.018 1.794 3.66 4 3.66s4-1.642 4-3.66v-.34h3.362a1.63 1.63 0 0 0 1.511-1.01 1.632 1.632 0 0 0-.352-1.784Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Notify_me_red_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C00",
    d: "M0 0h24v24H0z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 1a5 5 0 1 0 0 10 5 5 0 0 0 0-10Z",
    fill: "#FF4E43"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 1a5 5 0 1 0 0 10 5 5 0 0 0 0-10",
    stroke: "#FAE6E6",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m18.148 4.803-2.284 3a.5.5 0 0 1-.395.197h-.003a.5.5 0 0 1-.394-.192l-1.216-1.553a.5.5 0 1 1 .788-.616l.816 1.043 1.892-2.485a.5.5 0 0 1 .796.606Z",
    fill: "#FAE6E6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Notify_me_red_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 1,
    width: 10,
    height: 11
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m18.148 4.803-2.284 3a.5.5 0 0 1-.395.197h-.003a.5.5 0 0 1-.394-.192l-1.216-1.553a.5.5 0 1 1 .788-.616l.816 1.043 1.892-2.485a.5.5 0 0 1 .796.606ZM16 1a5 5 0 1 0 0 10 5 5 0 0 0 0-10Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Notify_me_red_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10 0h12v12H10z"
  }))));
};
export default SvgNotifyMeRed;